<template>
    <div class="downloads content-wide" style="padding-top: 128px">
        <div class="content-img-container">
            <!-- <img src="@/assets/img/2.jpeg" :alt="$t('downloads.title')" /> -->
        </div>

     
        <h1 class="big-title">{{ $t('downloads.title') }}</h1>
        <div class="downloads-content">
            <div>
                <div class="downloads-section">
                    <h3>Logos</h3>
                    <a href="https://rudetins.ch/download-files/rudetins-logo-eps.eps" download>EPS</a>
                    <a href="https://rudetins.ch/download-files/rudetins-logo-white.png" download>PNG (weiss)</a>
                    <a href="https://rudetins.ch/download-files/rudetins-logo-black.png" download>PNG (schwarz)</a>
                </div>
                <div class="downloads-section">
                    <h3>Bandfoto</h3>
                    <a href="https://rudetins.ch/download-files/rudetins-foto.jpeg" download>JPEG</a>
                </div>
            </div>
            <div>
                <div class="downloads-section">
                    <h3>Biographie</h3>
                    <a href="https://rudetins.ch/download-files/rudetins-bio.pdf" download>PDF</a>
                </div>
                <div class="downloads-section">
                    <h3>Tech Rider</h3>
                    <a href="https://rudetins.ch/download-files/rudetins-stagerider.pdf" download>PDF</a>
                    <!--
                        <a href="https://www.dropbox.com/s/u3mo7ry2x4niigp/rudetins-stagerider-en.pdf?dl=1">English (PDF)</a>
                    -->
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./Downloads.ts"></script>
<style lang="scss" scoped>
@import './Downloads.scss';
</style>
